






















































































import {Vue, Component, Ref, Watch, PropSync} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {SelectWings} from "@/components";
import { CollapseTransition } from "vue2-transitions";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {readFileAsBinary, readFileAsText} from "@/utils/download-helper"
import {BlacklistImportRequest} from "@/store/blacklists/types";

@Component({components: {CollapseTransition,SelectWings}})
export default class ImportContacts extends Vue {
  @PropSync('show') is_show!: boolean;
  @PropSync('blacklist_id') blacklistId!: number;
  @Ref('validator') validator: any;
  @Action("importBlackListContacts") actionImport: any;
  @Action("preImport") actionPreImport: any;
  @Getter delimiterList:any;

  defaultImportRequest(): BlacklistImportRequest {
    return new BlacklistImportRequest(this.blacklistId)
  }

  importRequest = this.defaultImportRequest()
  file: any = null
  fieldTypes = this.defaultFieldTypes()
  fields = []
  autoImport = true
  isTextFile = false

  defaultFieldTypes() {
    return ['MSISDN', 'EMAIL','COMMENT']
  }

  get fieldTypeNames() {
    return this.fieldTypes.map((item:any) => this.$t('contacts.types.'+item))
  }

  @Watch('autoImport')
  onAutoImportChanged(val: boolean) {
    if (!val) this.readFile()
  }

  @Watch('importRequest.separator')
  onSeparatorChanged(val: boolean) {
    this.readFile()
  }

  onFileUpload (evt:any) {
    this.file = evt[0]
    this.readFile()
  }

  async readFile() {
    if (this.autoImport) return
    if (!await this.validator.validate()) return
    try {
      this.isTextFile = false
      if (["text/csv", "text/plain"].includes(this.file.type)) {
        this.isTextFile = true
        const fileData = await readFileAsText(this.file)
        const firstrow = fileData.split('\n').shift()
        this.fields = firstrow.split(this.importRequest.separator)
      }
      else
      {
        this.fields = await this.actionPreImport({
          separator: this.importRequest.separator,
          fileName: this.importRequest.fileName,
          file: btoa(await readFileAsBinary(this.file))
        })
      }
      this.importRequest.fieldSequence = this.fields.map(() => '')

    } catch (error) {
      console.log(error)
      notifyError(error);
    }
  }

  async importFile():Promise<void> {
    if (!await this.validator.validate()) {
      notifyError(null, this.validator.errors)
      return
    }
    if (!this.autoImport) {
      const isFilled = this.importRequest.fieldSequence.find((item:string) => item == 'MSISDN' || item == 'EMAIL')
      if (!isFilled) {
        notifyError(null, null, this.$t('contacts.messages.requiredMissing').toString())
        return
      }
      const fieldSequenceFiltered = this.importRequest.fieldSequence.filter((item:string) => item != '')
      const isDuplicates = new Set(fieldSequenceFiltered).size !== fieldSequenceFiltered.length
      if (isDuplicates) {
        notifyError(null, null, this.$t('contacts.messages.fieldTypeDuplicates').toString())
        return
      }
    }
    try {
      this.importRequest.blackListId = this.blacklistId
      this.importRequest.file = btoa(await readFileAsBinary(this.file))
      if (this.autoImport) this.importRequest.fieldSequence = this.defaultFieldTypes()

      const data = await this.actionImport(this.importRequest);
      const msg = [this.$t('contacts.messages.importCount').toString() + data?.contactsCount]
      msg.push(this.$t('contacts.messages.msisdnDuplicates').toString() + data?.msisdnDuplicateCount)
      if (data?.msisdnDuplicates.length) msg.push(data?.msisdnDuplicates.join(', '))
      msg.push(this.$t('contacts.messages.failedMsisdns').toString() + data?.failedMsisdnCount)
      if (data?.failedMsisdns.length) msg.push(data?.failedMsisdns.join(', '))
      msg.push(this.$t('contacts.messages.emailDuplicates').toString() + data?.emailDuplicateCount)
      if (data?.emailDuplicates.length) msg.push(data?.emailDuplicates.join(', '))
      msg.push(this.$t('contacts.messages.failedEmails').toString() + data?.failedEmailCount)
      if (data?.failedEmails.length) msg.push(data?.failedEmails.join(', '))

      notifySuccess(msg.join('<br>'));
      this.$emit('refresh')
      this.importRequest = this.defaultImportRequest()

    } catch (error) {
      notifyError(error);
    }
  }
}
